module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"popup-card\"> <button type=\"button\" class=\"btn btn-sm btn-secondary show-popup\">")
    ; __append(escapeFn( locals.title ))
    ; __append("</button> <div class=\"card\"> <div class=\"card-body\"> <div class=\"d-flex justify-content-between\"> <h5 class=\"m-0\">")
    ; __append(escapeFn( locals.title ))
    ; __append("</h5> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </div> <form> ")
    ;  _.each(locals.dropdownSelections, function(dropdownSelection, idx) { 
    ; __append(" <div class=\"form-group\"> <div id=\"")
    ; __append(escapeFn( locals.computeSelectionViewId(idx) ))
    ; __append("\"></div> </div> ")
    ;  }); 
    ; __append(" ")
    ;  _.each(locals.formFields, function(formField) { 
    ; __append(" <div class=\"form-group\"> ")
    ;  if (formField.label) { 
    ; __append(" <label class=\"dropdown-label\">")
    ; __append(escapeFn( formField.label ))
    ; __append("</label> ")
    ;  } 
    ; __append(" <input name=\"")
    ; __append(escapeFn( formField.paramKey ))
    ; __append("\" value=\"")
    ; __append(escapeFn( formField.defaultValue ))
    ; __append("\" placeholder=\"")
    ; __append(escapeFn( formField.placeholder))
    ; __append("\" type=\"")
    ; __append(escapeFn( formField.type ))
    ; __append("\" class=\"form-control border-0 p-0\"> </div> ")
    ;  }); 
    ; __append(" <button class=\"btn btn-secondary\" type=\"submit\">Create ")
    ; __append(escapeFn( locals.objectName ))
    ; __append("</button> </form> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/popup_create_form/template.ejs
// module id = 1197
// module chunks = 1